export const ru = {
  tabs: {
    main: 'Главная',
    friends: 'Друзья',
    profile: 'Паспорт',
    tasks: 'Задания',
    leaderboard: 'GIGI',
  },
  controls: {
    close: 'Закрыть',
  },
  webappPopup: {
    error: 'Ошибка',
    tgVersionIncompatibleSharing: 'Эта версия Telegram не поддерживает функцию "поделиться"!',
    processUnable: 'Мы не можем обработать твою заявку в данный момент',
    noLootboxes: 'Мы сохранили твою заявку, но нет доступных лутбоксов, пожалуйста, попробуйте позже',
    loginToBuy: 'Тебе нужно быть авторизованным, чтобы купить больше ключей',
    needTgPremiumForStories: 'Тебе нужно быть Telegram Premium пользователем, чтобы делиться историями',
    tgVersionTooOldForStories: 'Версия Telegram слишком старая, чтобы делиться историями',
    tryAgain: 'Пожалуйста, попробуйте позже!',
    alreadyConnected: 'Вы уже авторизованы!',
    ableToUpdate: 'Вы можете обновлять прогресс единожды каждые 24 / 12 часов для премиус пользователей',
    inviteMoreFriends: 'Вам нужно пригласить большей друзей',
    notSupportedOnDevice: 'Эта возможность не поддерживается на вашем устройстве',
  },
  pages: {
    openEgs: {
      title: 'Настройка приватности EGS',
      sub: 'Для того, чтобы GAMED мог получать актуальную статистику и информацию о вашем игровом портфеле, необходимо открыть возможность просмотра вашего аккаунта Epic Games.',
      step: 'Этап',
      openEgs: (onClick: () => void) => (
        <span>
          Откройте приложение Epic Games Store или зайдите на{' '}
          <span
            style={{ color: '#4A6BFC' }}
            onClick={onClick}
          >
            портал учётной записи Epic
          </span>
          .
        </span>
      ),
      myAchievements: (
        <span>
          После авторизации нажмите на ваш аватар в правом верхнем углу экрана и перейдите в раздел{' '}
          <span style={{ color: 'white' }}>“Мои достижения”</span>.
        </span>
      ),
      threeDots: (
        <span>
          Нажмите на три точки рядом с полем <span style={{ color: 'white' }}>“Уровень конфидециальности”</span>. В
          выпадающем меню выберите <span style={{ color: 'white' }}>“Управление конфиденциальностью”</span>.
        </span>
      ),
      openProfile: (
        <span>
          В разделе “Управление конфиденциальностью” выберите <span style={{ color: 'white' }}>“Открытый профиль”</span>
          . Благодаря этому мы сможем получать информацию о вашем{' '}
          <span style={{ color: 'white' }}>игровом наследии</span> на платформе.
        </span>
      ),
    },
    recommendations: {
      title: 'Рекомендованные игры',
      subtitle: 'На этом экране мы собрали для вас небольшую коллекцию рекомендуемых игр!',
    },
    onboarding: {
      title: 'Добро пожаловать!',
      text: (
        <>
          Задумывались ли вы когда-нибудь о том, что будете получать награды за свое{' '}
          <span style={{ color: 'white' }}>игровое время</span> и <span style={{ color: 'white' }}>достижения</span>?
        </>
      ),
      text2: (
        <>
          GAMED воплощает эти фантазии в <span style={{ color: 'white' }}>реальность</span>! Мы проанализируем ваш
          игровой профиль Steam и подготовим для вас <span style={{ color: 'white' }}>достойное вознаграждение</span>.
        </>
      ),
      button: 'Далее',
      buttonSecond: 'Продолжить без авторизации',
    },
    tonConnect: {
      title: 'Подключение кошелька TON',
      text: 'Нет аккаунта Steam? Что ж, приятель, тогда тебе придется подключить TON-кошелек, чтобы заявить о себе в экосистеме и присоединиться к активностям в GAMED. Но имей в виду — настоящие плюшки достаются тем, кто подключил Steam и подтвердил свои игровые заслуги.',
      button: 'ПОДКЛЮЧИТЬ',
      buttonSecond: 'ПОЗЖЕ',
    },

    tggift: {
      heading: 'Подарки Telegram уже в GAMED!',
      desc: (
        <>
          <p>
            В GAMED новое обновление! Мы представляем уникальный набор{' '}
            <span style={{ color: 'white' }}>Telegram Gift Case</span>, в котором вместе с ценными GAMED-поинтами вы
            можете получить <span style={{ color: 'white' }}>подарки</span> Telegram.
          </p>
          <p>
            Бот автоматически выберет доступный подарок и начислит его на ваш аккаунт. Кстати, стандартные подарки можно
            улучшить до NFT в вашем профиле Telegram!
          </p>
        </>
      ),
      notation: (
        <p>
          Все полученные подарки можно <span style={{ color: 'white' }}>оставить</span> у себя в профиле - по умолчанию
          они будут видны для всех пользователей Telegram!
        </p>
      ),
      info: {
        title: 'Telegram Gifts!',
        desc: 'Открывайте новый кейс и получайте памятные награды!',
      },
    },
    main: {
      monetize: 'Монетизируй свое игровое время',
      earn: 'Получай реальные награды за игровой прогресс',
      receive: 'Получай актуальную статистику по всем своим играм',
      shareLegacy: 'Поделиться наследием',
      tgCase: 'Telegram Gift Case',
      inviteFriends: 'Пригласить друзей',

      gigiInfo:
        'GIGI (Global Index of Gamer Impact) - это рейтинговая система на основе ИИ, разработанная для оценки общего влияния, мастерства и портфеля игрока на различных платформах.',
      last_update: 'с последнего обновления',
      joinCommunity: 'Вступить в сообщество',
      share_progress: 'Поделиться',
      update_progress: 'Обновить прогресс',
      specialEvent: 'Особое событие!',
      validateLegacy: 'Валидируй свое игровое наследие',
      updateNow: 'Ускорить',
      freeUpdate: 'До обновления:',
      joinGiveaway: 'Join The Giveaway',
      timer_text: 'Обновить через',
      joinPlaytest: 'Регистрация Farcana Playtest!',
      steamOn: 'Steam On!',
      arrival: 'Новинка!',
      joinGiveaway2: 'Участвуй в конкурсе!',
      arrival2: 'Новое поступление!',
      steamDeck: 'Steam On! Case',
      ambassador: 'Ambassador Case',
      cargo: 'CARGO Case',
      platforms: 'Платформы',
      gamedRewards: 'Награды',
      rewards: 'Ежедневные награды и кейсы',
      news: 'Что нового?',
      topUpSteam: 'Пополнение Steam',
      statuses: {
        Available: 'Доступен',
        Connected: 'Подключен',
        Soon: 'Скоро',
        Legacy: 'Наследие',
      },
      connect_button: 'Подключить',
      connect_steam: 'Подключить Steam',
      no_steam_account: 'У меня нет Steam аккаунта',
      modal_content:
        'Можешь не переживать, ты войдешь через официальную страницу Steam — мы не можем увидеть твой пароль, даже если хотели бы! Нам нужны только вкусные штуки: публичные игровые данные, чтобы осыпать тебя поинтами GAMED.',
      modal_title: 'Подключение Steam',
      steam_modal_content: 'Мы не увидим твой логин или пароль!',
      // paragraph1: 'Для анализа игрового профиля и наград, пожалуйста, привяжите ваш аккаунт Steam.',
      paragraph1: (
        <span>
          Для анализа <span style={{ color: 'white' }}>игрового профиля</span> и{' '}
          <span style={{ color: 'white' }}>наград</span>, пожалуйста, привяжите ваш аккаунт Steam.
        </span>
      ),
      paragraph2: (
        <>
          Мы не получаем доступ к вашим личным данным и паролю, так как авторизация проходит через официальный{' '}
          <span style={{ color: 'white' }}>сайт Steam</span>.
        </>
      ),

      whatDataLink: 'Какие данные мы используем?',

      widgetText: {
        title: 'Подключите свой аккаунт Steam, чтобы начать зарабатывать $GAMED',
        sub_title: 'Почему стоит подключить Steam аккаунт?',
        list_item_1: 'Отслеживайте свои игровые часы и достижения',
        list_item_2: 'Зарабатывайте $GAMED за свой игровой прогресс',
        list_item_3: 'Соревнуйтесь в таблице лидеров с другими игроками',

        keysAndRewards: {
          needMoreKeys: 'Нужно больше ключей?',
          buyKeysAndUse: 'Покупай ключи и используй их для получения дополнительных наград!',
          yourKeys: 'Ключи:',
          freeBoxIn: 'Кейс через',
          viewRewards: 'Подробнее',
          canClaim: 'Ключ готов!',
          readyToOpen: 'Можно открыть!',
          keys: 'Ключей',
          stars: 'Stars',
          package: 'Пакет',
          price: 'Цена',
        },
      },
      dailyCaseBanner: {
        yourKeys: 'Твои Ключи:',
        freeCaseIn: 'Бесплатный кейс через:',
        viewRewards: 'Подробнее',
        claimReward: 'Получить награду',
      },
      subscriptionDrawer: {
        description:
          'Получите дополнительные функции и расширенную статистику аккаунта, бонусные GAMED поинты, ежедневные награды и многое другое.',
        aldreadySubscribed: 'Подписка Plus активна. Наслаждайтесь расширенными функциями GAMED Plus!',
        alreadyPlus: 'Благодаря GAMED Plus вы получаете доступ к расширенной статистике и ускоренному фарму GAMED!',
        alreadyPlatinum:
          'Благодаря GAMED Platinum вы получете доступ к расширенной статистике и уникальным бонусам к фарму GIGI и GAMED!',
        enjoyFeatures: '',
        valid: 'ДЕЙСТВИТЕЛЬНО ДО',
        add: 'Добавь 500K',
        toGet: 'и получи',
        discount: '30% скидку',
        getPlus: 'Приобрести за ',
        later: 'Позже',
        columns: {
          feature: 'Функции',
          basic: 'Стандарт',
          plus: 'Plus',
        },

        features: {
          // extra_update_bonus: 'Бонус за обновление',
          // free_reroll: 'Улучшенный дроп',
          // free_gamed_box: 'Бонусный GAMED Case',
          // games_owned: 'Игры в библиотеке',
          // items_owned: 'Кол-во предметов',
          // total_account_value: 'Стоимость аккаунта',
          // total_playtime: 'Игровое время',
          // daily_playtime: 'Среднее время в игре',
          // account_age: 'Возраст аккаунта',
          // registration_date: 'Дата регистрации',
          // inventory_price: 'Стоимость инвентаря',
          // favorite_genre: 'Любимый жанр',
          advancedStatistics: 'Расширенная статистика',
          improvedDrop: 'Улучшенный дроп',
          recommendations: 'Рекомендации игр',
          moreGigi: 'Больше GIGI за время',
          moreGamed: 'Больше GAMED за задания',
          freeCase: 'Бесплатный кейс',
          updateProgress: 'Обновление прогресса',
        },
      },

      newYear: {
        heading: 'Розыгрыш 20 Steam Gift Cards!',
        description: 'Не упусти халяву от GAMED только с 1 по 7 января!',
        playFavorite: 'Играй в любимые игры...',
        weKnow: '(знаем, ты уже это делаешь)',
        updateProgress: 'И обновляй прогресс!',
        inGamedApp: 'посещая GAMED кажый день',
        rules:
          'Уже 7 января мы случайным образом выберем 20 счастливчиков и отправим гифт карты (от $10 до $50) прямо на их аккаунты.',
      },
      recalculating: {
        heading: 'Перерасчет экономики GAMED!',
        description:
          'В этом обновлении мы скорректировали работу алгоритма оценки профилей. Все заработанные GAMED останутся при вас - их количество только увеличится!',
        notation:
          'Стоимость аккаунтов не изменилась пропорционально - мы лишь убрали дробные части в алгоритме оценки стоимости аккаунта, негативно влияющие на пользовательский опыт.',
        stats: {
          valueChanged: 'Стоимость вашего аккаунта была перерасчитана по новому алгоритму',
          openedBoxes: 'Если вы открыли GAMED Case в прошлом обновлении, вы получите справедливую компенсацию',
        },
      },
    },
    profile: {
      shareLegacy: 'Поделиться наследием',
      games4u: 'Игры для тебя',
      addFriend: 'Добавить в друзья',
      privateAccount: 'Приватный аккаунт',
      removeFriend: 'Удалить из друзей',
      meet: 'ПРИВЕТСТВУЕМ',
      status: 'успешно подключен',
      total_steam_value: 'Стоимость Аккаунта',
      balance: 'Баланс',
      updateIn: 'До обновления',
      updating: 'Обновление...',
      gamingLegacy: 'Игровое наследие',
      externalGamingLegacy: 'Игровое наследие',
      expensiveItems: 'Дорогие предметы',
      private: 'Приватный аккаунт',
      lastUpdate: 'Последнее обновление:',
      updateProgress: 'Обновить прогресс',
      favoriteGames: 'Любимые игры',
      now: 'Ускорить',
      totalAssets: 'TVGA',
      rewards: 'Награды',
      tabs: {
        overview: 'Общее',
        games: 'Игры',
        items: 'Инвентарь',
      },
      unifiedStats: {
        totalAccVal: 'Стоимость аккаунтов',
        totalAssPur: 'Стоимость ассетов',
        totalHrPlayed: 'Общее кол-во часов',
        dailyPlaytime: 'Среднее время игры в день',
        gamesOwned: 'Игры в библиотеке',
        itemsOwned: 'Общее кол-во предметов',
      },
      overview: {
        games_owned: 'Игры в библиотеке',
        items_owned: 'Кол-во предметов',
        total_hours_played: 'Общее игровое время',
        account_value: 'Стоимость аккаунта',
        total_playtime: 'Total Playtime',
        account_age: 'Возраст аккаунта',
        inventory_price: 'Стоимость ассетов',
        registration_date: 'Дата регистрации',
        daily_playtime: 'Среднее время в играх',
        favorite_genre: 'Любимый жанр',

        features: 'Возможности',
        recomended: 'Рекомендации',
        recommendedGames: 'Вам может понравиться',
      },
      gameList: {
        unit: 'Ч',
      },
      itemsList: {
        error: 'Нет предметов',
      },

      stories: {
        meetThe: 'ПРИВЕТСТВУЕМ',
        mainStories: {
          connectedPlatforms: 'Подключенные платформы',
          stats: {
            totalPlaytime: 'Общее время в играх',
            accountsValue: 'Стоимость аккаунтов',
            assetsValue: 'Стоимость ассетов',
            gamesOwned: 'Количество игр',
            itemsOwned: 'Количество предметов',
            totalGigi: 'Всего GIGI',
            gigiForAssets: 'GIGI за ассеты',
            gigiForGames: 'GIGI за игры',
            gigiForHours: 'GIGI за часы',
          },
        },
        lastProgress: {
          stats: {
            gamesOwned: 'Игры в библиотеке',
            itemsOwned: 'Кол-во предметов',
            totalPlaytime: 'Игровое время',
            accountValue: 'Цена Аккаунта',
            hours: 'Ч',
          },
        },
        steamProfile: {
          totalGamedValue: 'МОЯ НАГРАДА В GAMED',
          stats: {
            totalPlaytime: 'Общее время в играх',
            accountValue: 'ЦЕНА АККАУНТА',
          },
        },
      },
    },
    farcanaProfile: {
      rewards: 'Награды',
      connectedSuccessfully: '◉ Аккаунт Farcana успешно подключен',
      registrationLink: 'Загрузить Farcana',
      stats: {
        totalHoursPlayed: 'Общее игровое время',
        totalAssetsValue: 'Стоимость ассетов',
        dailyStreakLength: 'Ежедневный стрик',
        registrationDate: 'Дата Регистрации',
        totalMatchesPlayed: 'Матчей сыграно',
        averageDailyPlaytime: 'Среднее время игры в день',
        KDA: 'КД',
        winrate: 'Винрейт',
      },
    },
    epicProfile: {
      connectedSuccessfully: '◉ Аккаунт Epic Games успешно подключен',
      favgames: 'Любимые Игры',
      noGames: 'У вас нет игр в библиотеке!',
      legacy: 'Игровое наследие',
      stats: {
        accountValue: 'Стоимость Аккаунта',
        gamesOwned: 'Игры в библиотеке',
        achievements: 'Достижения',
        xp: 'Опыт',
      },
    },

    friends: {
      yourFriends: 'Твои друзья',
      noFriends: 'У тебя пока нет друзей!',
      user: 'Пользователь',
      header: (props: { firstLevel: number; secondLevel: number }) => (
        <p>
          Приглашайте друзей, чтобы получать&nbsp;
          <span>{props.firstLevel && props.firstLevel != 10 ? <div>{props.firstLevel}%</div> : '10%'}</span>
          &nbsp;от их наград, плюс&nbsp;
          <span>{props.secondLevel && props.secondLevel != 5 ? <div>{props.secondLevel}%</div> : '5%'}</span>
          &nbsp;от их приглашений. Убедитесь, что они подключают
          <span> Steam</span> для <span>максимальных</span> наград.
        </p>
      ),
      earned_today: 'Заработано сегодня',
      expires: 'Исчезнут через',
      no_tokens: 'Нет наград',
      tokens_claimed: 'Награда зачислена',
      total_earned: 'Всего заработано',
      directed_friends: 'Ваши друзья',
      second_lvl_friends: 'ДРУЗЬЯ ДРУЗЕЙ',
      ambassadorInfo: (handleClick: () => void) => (
        <span>
          Амбассадоры и инфлюенсеры могут получить особые преимущества, связавшись с представителями GAMED в{' '}
          <span
            style={{ color: '#4A6BFC' }}
            onClick={handleClick}
          >
            официальном чате
          </span>
        </span>
      ),
    },
    shop: {
      transactionSuccess: 'Транзакция успешно выполнена.',
      transactionProcessing: 'Транзакция обрабатывается.',
      selectCurrency: 'Выберите способ оплаты',
      heading: 'Выгодно!',
      messageSupport: (handleClick: () => void) => (
        <span>
          Если вы столкнулись с ошибками или сбоями в процессе проведения транзакции, напишите в{' '}
          <span
            onClick={handleClick}
            style={{ color: 'rgba(74, 107, 252, 1)', cursor: 'pointer' }}
          >
            наш support-бот
          </span>
          !
        </span>
      ),
      standardBundles: 'Стандартные наборы',
      subHeading: (
        <span>
          Приобретайте ключи для открытия кейсов. Для стабильной оплаты в TON используйте{' '}
          <span style={{ color: 'rgba(30, 255, 0, 1)' }}>VPN</span> и{' '}
          <span style={{ color: 'rgba(30, 255, 0, 1)' }}>мобильный клиент</span> Telegram!
        </span>
      ),
    },
    tasks: {
      labels: {
        daily: 'Ежедневные',
        general: 'Основные',
      },
      modalText:
        'Чтобы выполнить задание, вам необходимо обновить свой прогресс. Обязательно завершите игровую сессию необходимой длины перед обновлением!',
      steamOn: 'CONNECT & WIN!',
      steamOnDescription: (
        <span>
          Специальное 14-дневный ивент с более чем 200 реальными призами для игроков! Открывайте кейсы, выполняйте
          задания и получайте шанс выиграть <span style={{ color: 'white' }}>Steam Deck</span>,{' '}
          <span style={{ color: 'white' }}>PS5 Limited Edition</span> и подарочные карты{' '}
          <span style={{ color: 'white' }}>Steam</span>!
        </span>
      ),
      connectNwinDesc: (
        <>
          Ивент с <span style={{ color: 'white' }}>реальными призами</span> для игроков! Открывай кейсы и выполняй
          задания, чтобы выиграть <span style={{ color: 'white' }}>Steam Deck</span>,{' '}
          <span style={{ color: 'white' }}>PS5 Limited Edition</span>,{' '}
          <span style={{ color: 'white' }}>Steam Gift Cards</span> и другие награды!
        </>
      ),
      heading: 'Задания',
      inGame: 'Задания из игр',
      dailyTasks: 'Ежедневные задания',

      name: {
        x: 'GAMED в X (Twitter)',
        addSteam: 'Подключи Steam',
        vote: 'Голосуй за GAMED!',
        addEpic: 'Подключи Epic Games',
        gamedCommunity: 'GAMED Community',
        gamedChat: 'GAMED Chat',
        addToHomeScreen: 'Главный экран',
        tonConnect: 'TON Connect',
        addEmoji: 'GAMED Emoji',
        boost: 'Boost!',
        friends3: 'Пригласи 3 друзей',
        openSteamOn: 'Открой Steam On! Case',
        openPs5: 'Открой PS 5 Limited Case',
        friends5: 'Пригласи 5 друзей',
        streaks: 'Streaks',
        tApps: 'Trending Apps',
        postStory: 'Опубликуй Story',
        updateProgress: 'Обновляй прогресс',
        play: 'Играй в ',
        friends1: 'Пригласи друга',
        xPost: 'Сделай ретвит!',
        yesCoin: 'Присоединяйся к кампании Yescoin!',
        boinkersMoon: 'Отправь 3 Boinkers на Луну',
        tradeStormTrade: 'Соверши сделку в StormTrade',
        boinkersSlut: 'Прокрути слот-машину 10 раз',
        joinUpscale: 'Присоединяйся к Upscale в X',
        pokergram: 'Сыграй 3 руки в Pokergram',
        tradeUpscale: 'Соверши сделку в Upscale',
      },

      description: {
        x: 'Подпишись на официальный канал',
        vote: 'Проголосуй за проект в Telegram Apps Center',
        addSteam: 'Верифицируй свои достижения',
        addEpic: 'Верифицируй свои достижения',
        gamedCommunity: 'Подписывайся на сообщество',
        gamedChat: 'Присоединйся к коммьюнити',
        tonConnect: 'Подключи TON-кошелек к GAMED',
        addToHomeScreen: 'Добавь GAMED на рабочий стол',
        addEmoji: 'Добавь эмоджи GAMED в профиль',
        boost: 'Забусти наш Telegram-канал',
        friends1: '',
        friends3: '',
        friends5: '',
        openSteamOn: '',
        openPs5: 'Опционально',
        streaks: 'Приоединяйся к Streaks и выигрывайте TON, USDT и другие призы',
        tApps: 'Исследуй больше Web3 приложений',
        play: 'Играй в ',
        xPost: 'Поделись постом сообщества',
        playDesc: 'на протяжении 2 часов и обновляй прогресс',
        postStory: 'Поделись прогрессом с друзьями',
        updateProgress: 'Актуализируй статистику и получай ценные награды',
        yesCoin: 'Получи шанс выиграть награду!',
        boinkersMoon: '',
        tradeStormTrade: '',
        boinkersSlut: '',
        pokergram: '',
        tradeUpscale: '',
        joinUpscale: 'Подписывайся на наших партнеров!',
      },
    },

    connectPlatform: {
      egs: {
        connect_button: 'Connect',
        connect: 'Подключить аккаунт',
        reject: 'Вернуться на главный экран',
        modal_content: `-`,
        title: 'Подключение Epic Games',
        securityAlert: 'Ваши данные под надежной защитой!',
        paragraph1: (
          <span>
            Для анализа вашего<span style={{ color: 'white' }}> игрового профиля</span>, и получения ценных наград
            подключите ваш аккаунт <span style={{ color: 'white' }}>Epic Games</span>!
          </span>
        ),
        paragraph2: (
          <span>
            Мы не получаем доступ к вашим личным данным и паролю, так как авторизация проходит через официальный сайт
            Epic Games.
          </span>
        ),
        whatDataLink: 'Как открыть аккаунт EGS?',
      },
      steam: {
        connect_button: 'Подключить',
        connect: 'Подключить Steam',
        reject: 'У меня нет Steam аккаунта',
        modal_content:
          'Можешь не переживать, ты войдешь через официальную страницу Steam — мы не можем увидеть твой пароль, даже если хотели бы! Нам нужны только вкусные штуки: публичные игровые данные, чтобы осыпать тебя поинтами GAMED.',
        title: 'Подключение Steam',
        securityAlert: 'Мы не увидим твой логин или пароль!',
        paragraph1: (
          <span>
            Для анализа <span style={{ color: 'white' }}>игрового профиля</span> и{' '}
            <span style={{ color: 'white' }}>наград</span>, пожалуйста, привяжите ваш аккаунт Steam.
          </span>
        ),
        paragraph2: (
          <>
            Мы не получаем доступ к вашим личным данным и паролю, так как авторизация проходит через официальный{' '}
            <span style={{ color: 'white' }}>сайт Steam</span>.
          </>
        ),

        whatDataLink: 'Какие данные мы используем?',
      },
      farcana: {
        connect_button: 'Connect',
        connect: 'Подключить аккаунт',
        reject: 'Вернуться на главный экран',
        modal_content: `You will be authenticated directly through Steam’s official page. Your login and password remain completely confidential and are not shared with GAMED. \nWe only access your public gaming information (such as hours played and achievements) to reward you with points on our platform.`,
        title: 'Подключение Farcana',
        securityAlert: 'Ваши данные надежно защищены!',
        paragraph1: (
          <span>
            Присоединяйтесь к <span style={{ color: 'white' }}>Farcana</span>, захватывающему{' '}
            <span style={{ color: 'white' }}>шутеру 5v5</span>, с уникальными игровыми механиками и разнообразными
            героями!
          </span>
        ),
        paragraph2: (
          <span>
            Мы не получаем доступ к вашим личным данным и паролю, так как авторизация проходит через{' '}
            <span style={{ color: 'white' }}>официальный сайт</span> Farcana.
          </span>
        ),
        whatDataLink: 'What data are we using?',
      },
    },
    boxPage: {
      availableCases: 'Доступные кейсы',
      legacy: 'Наследие',
      tprem: 'Telegram Premium на 1 год',
      expired: 'Закончился',
      showMore: 'Покажи мне больше',
      uniqueGift: 'Подарок',
      yourKeys: 'Твои ключи',
      standardRewards: 'Стандартные Награды',
      claimed: 'Получено',
      heading: {
        cases: 'Кейсы',
        description: 'Описание',
      },

      uniqueContent: {
        heading: 'Уникальная Награда',
        title: 'Награды от партнера',
        ambassadorCase: {
          uniqueRewards: 'Уникальные награды от амбассадора',
          uniqueGift: 'Подарок',
        },

        steamDeck: {
          title: 'Steam Deck',
          subTitle: 'Поторопитесь, количество консолей ограничено!',
        },
        cityHolder: {
          title: 'Уникальный',
        },
      },

      descriptions: {
        gamed: (
          <p>
            Стандартный кейс, который доступен бесплатно раз в сутки. Содержит GAMED-поинты, необходимые для получения
            ценных наград и бонусов.
          </p>
        ),
        tgGift: (
          <span>
            <p>
              Этот кейс содержит случайные Telegram Gifts, которые украсят ваш профиль Telegram. Кейс также содержит
              очки GAMED!
            </p>
            <br />
            <p>Обратите внимание: награды Telegram будут автоматически зачислены на ваш аккаунт ботом GAMED.</p>
          </span>
        ),

        vavilova: (
          <span>
            <p>
              Совместно с нашим амбассадором Юлией Вавиловой мы разработали уникальный кейс, в котором у вас есть
              возможность выиграть уникальные NFT-подарки.
            </p>
            <br />
            <p>Кейс будет доступен в течение короткого времени, а количество подарков строго ограничено!</p>
          </span>
        ),
        cargo: (
          <span>
            <p>
              Этот кейс содержит увеличенное количество GAMED-поинтов. Больше нет необходимости открывать сотни
              стандартных кейсов - получите всё и сразу в одном наборе!
              <br />
              <br />
              Обратите внимание: для приобретения доступно всего 100 CARGO-кейсов!{' '}
            </p>
          </span>
        ),
        steamDeck: (
          <span style={{ margin: '0', textWrap: 'pretty' }}>
            <p style={{ textWrap: 'pretty', marginBottom: '16px' }}>
              Этот кейс содержит GAMED-поинты, ваучеры на подписку GAMED Plus (на 6 и 12 месяцев), ваучер на уникальный
              Telegram-подарок, а также уникальную награду - консоль Steam Deck!
            </p>
            <p style={{ textWrap: 'pretty' }}>
              Обратите внимание: бот автоматически отправит вам сообщение о выигрыше, после чего представители GAMED
              свяжутся с вами!
            </p>
          </span>
        ),
        cityholder: (
          <span style={{ margin: '0', textWrap: 'pretty' }}>
            <p style={{ textWrap: 'pretty', marginBottom: '16px' }}>
              Совместно с City Holder мы разработали уникальный кейс, в котором у вас есть возможность выиграть награды
              от партнера и GAMED-поинты!
            </p>
            <p style={{ textWrap: 'pretty' }}>
              Кейс будет доступен в течение короткого времени. Обратите внимание: пользователи, не имеющие аккаунта в
              City Holder, будут получать только награды GAMED. Партнерские награды буду автоматически начислены на ваш
              аккаунт City Holder!
            </p>
          </span>
        ),

        ps5: (
          <span style={{ margin: '0', textWrap: 'pretty' }}>
            <p style={{ textWrap: 'pretty', marginBottom: '16px' }}>
              Этот кейс содержит GAMED-токены, ваучеры на подписку GAMED Plus (на 6 и 12 месяцев), ваучер на уникальный
              Telegram-подарок, а также уникальную награду - лимитированную{' '}
              <span style={{ color: 'white' }}>Playstation 5</span>, выполненную в стилистике{' '}
              <span style={{ color: 'white' }}>PS 1</span>!
            </p>
            <p style={{ textWrap: 'pretty' }}>
              Обратите внимание: бот автоматически отправит вам сообщение о выигрыше, после чего представители GAMED
              свяжутся с вами!
            </p>
          </span>
        ),
        telegamApps: (
          <span style={{ margin: '0', textWrap: 'pretty' }}>
            <p style={{ textWrap: 'pretty', marginBottom: '16px' }}>
              Этот кейс содержит выпущен в коллаборации с Telegram Apps Center и содержит увеличенное количество
              GAMED-поинтов по сранению со стандартным Gamed Case.
            </p>
            <p style={{ textWrap: 'pretty' }}>
              Кейс будет доступен ограниченное время. Обязательно не забудьте проголосовать за GAMED в Telegram Apps
              Center, чтобы поддержать проект!
            </p>
          </span>
        ),
      },

      widgetTexts: {
        boxReady: 'GAMED кейс готов',

        lootBoxScaled: {
          limited: 'Лимитированный',
          boxRelated: {
            trending: {
              description: (
                <p>
                  Особенный бокс, созданный в коллаборации с <span>Telegram Apps Center</span>.
                </p>
              ),
              availableFor: (
                <p>
                  Доступен <span>ограниченное время</span> и содержит <span>увеличенные награды</span>!
                </p>
              ),
            },
            tgGift: {
              description: (
                <p>Получайте уникальные подарки в Telegram и ускоряйте свой прогресс с помощью очков GAMED!</p>
              ),
              availableFor: null,
            },
            gamed: {
              description: null,
              availableFor: null,
            },
            cityholder: {
              description: (
                <span>
                  Уникальный кейс для пользователей City Holder, в котором содержатся ценные награды и GAMED-поинты!
                </span>
              ),
            },
            vavilova: {
              description: (
                <span>
                  Уникальный кейс, в котором у вас есть шанс выиграть лимитированные подарки от нашего амбассадора{' '}
                </span>
              ),
              availableFor: null,
              name: (handleClick: () => void) => (
                <span
                  onClick={handleClick}
                  style={{ color: '#4A6BFC' }}
                >
                  Юлии Вавиловой
                </span>
              ),
            },
            cargo: {
              description: <p>Стратегический запас GAMED-поинтов для максимального ускорения прогресса!</p>,
              availableFor: null,
            },
            steamDeck: {
              description: (
                <p>
                  Поймайте удачу за хвост и получите шанс выиграть подписку GAMED Plus, уникальные Telegram-подарки, а
                  также приставку <span style={{ color: 'white' }}>Steam Deck</span>!
                </p>
              ),
            },
            ps5: {
              description: (
                <p>
                  Поймайте удачу за хвост и получите шанс выиграть подписку GAMED Plus, уникальные Telegram-подарки, а
                  также приставку<span style={{ color: 'white' }}> PlayStation 5 в дизайне PS1</span>!
                </p>
              ),
            },
            telegramApps: {
              description:
                'Особый кейс, выпущенный в рамках коллаборации с Telegram Apps Center. Содержит увеличенное количество GAMED-поинтов!',
            },
          },
          contain: 'Содержит: GAMED поинты.',
          canBeOpened: 'Выдается бесплатно каждые 24 Ч.',
          usersWith: 'Пользователи с',
          plusUsers: 'открывают GAMED Case вдвое быстрее!',
          withinCase: 'Содержит',

          modal: {
            gamed: 'Открыть GAMED Case?',
            trending: 'Открыть Trending Box?',
            tgGift: 'Открыть Telegram Gift Case?',
          },
        },

        dailyKey: {
          yourKeys: 'Твои ключи:',
          grabKey: 'КЛЮЧ ГОТОВ!',
        },

        filter: {
          all: 'Все',
        },

        buyKey: {
          bored: 'Надоело ждать? Купи!',
          buyKeys: 'В Магазин!',
        },
        opening: {
          heading: 'Открытие GAMED',
        },

        rewardClaim: {
          heading: 'Твоя награда',
          giftWorth: 'Gift Worth',
          headingStories: 'Моя награда',
          reroll: 'Повторить',
          uniqueGift: 'Unique Gift',
          congrats:
            'Поздравляем! Вы выиграли уникальный Telegram-подарок от амбассадора GAMED! Бот отправит вам подробную инструкцию по его получению.',
          rewardTypes: {
            Legendary: 'Легендарный',
            Epic: 'Эпический',
            Rare: 'Редкий',
            Uncommon: 'Необычный',
            Common: 'Обычный',
          },

          uniqueGifts: {
            trending: { heading: '', description: '' },
            tgGift: { heading: '', description: '' },
            gamed: { heading: '', description: '' },
            vavilova: { heading: '', description: '' },
            cargo: { heading: '', description: '' },
            steamDeck: {
              heading: 'Steam Deck',
              description:
                'Поздравляем! Вы выиграли уникальную награду - консоль Steam Deck. Бот GAMED отправит вам подробную инструкцию по её получению.',
            },
            ps5: {
              heading: 'PlayStation 5',
              description:
                'Поздравляем! Вы выиграли уникальную награду - консоль PlayStation 5. Бот GAMED отправит вам подробную инструкцию по её получению.',
            },
          },
        },
        modal: {
          openBox: 'Открыть GAMED кейс?',
        },
      },
    },
    news: {
      egs: {
        heading: 'Подключение Epic Games в GAMED!',
        notation: (
          <span>
            <p>
              В новом обновлении мы рады представить новый алгоритм анализа аккаунтов{' '}
              <span style={{ color: 'white' }}>Epic Games</span>! Подключение EGS уже доступно в разделе{' '}
              <span style={{ color: 'white' }}>"Платформы"</span> на главном экране, а обновление и синхронизация
              прогресса выполняется одновременно с другими подключенными платформами.
            </p>
            <p>
              Обратите внимание: мы обрабатываем данные только{' '}
              <span style={{ color: 'white' }}>открытых аккаунтов</span>, а сам алгоритм пока находится на этапе
              доработки. Кроме того, из-за мощной антибот-защиты EGS, некоторые пользователи неизбежно будут
              сталкиваться со сбоями при подключении.
            </p>
            <p>Отправляйтесь к новым победам вместе с GAMED!</p>
          </span>
        ),
      },
      steamOn: {
        heading: 'Connect & Win!',
        description: (
          // <span>
          //   10-дневный ивент с реальными призами для игроков! Выполни все задания и получи шанс выиграть{' '}
          //   <span style={{ color: 'white' }}>Steam Deck</span>, <span style={{ color: 'white' }}>PS5</span> и{' '}
          //   <span style={{ color: 'white' }}>Steam Gift Cards</span>!
          // </span>
          <span>
            Специальный 14-дневный ивент с более чем 200 реальными призами для игроков! Открывайте кейсы, выполняйте
            задания и получайте шанс выиграть <span style={{ color: 'white' }}>Steam Deck</span>,{' '}
            <span style={{ color: 'white' }}>PS5 Limited Edition</span> и подарочные карты{' '}
            <span style={{ color: 'white' }}>Steam</span>!
          </span>
        ),
        notation: (
          <>
            <div style={{ marginBottom: '6px' }}>
              <span style={{ color: 'white' }}>Основная награда:</span> Steam Deck, PS5 Pro 30th Year Edition, 100 шт.
              гифт-карт Steam по $10
            </div>
            <div style={{ marginBottom: '6px' }}>
              <span style={{ color: 'white' }}>Топовые скины CS:</span> Skeleton Knife | Stained, Shadow Daggers, AK
              Blue Laminate, Slate, Legion of Anubis.
            </div>
            <div style={{ marginBottom: '6px' }}>
              Победители будут выбраны в течение 3 дней после окончания ивента и объявлены в сообществе GAMED - следите
              за новостями!
            </div>
            <div style={{ marginBottom: '6px' }}>
              Конкурсные квесты доступны в разделе «Задания». Присоединяйтесь к нам и получайте уникальные награды!
            </div>
          </>
        ),
      },
      ambassador: {
        heading: 'Розыгрыш подарков от амбассадора!',
        description: (
          <p style={{ margin: '0', marginBottom: '12px' }}>
            Совместно с нашим амбассадором Юлией Вавиловой мы разработали уникальный кейс, в котором у вас есть
            возможность выиграть <span style={{ color: 'white' }}>уникальные Telegram-подарки</span>.
            <br />
            <br />
            Кейс будет доступен в течение короткого времени, а количество подарков{' '}
            <span style={{ color: 'white' }}>ограничено</span>!
          </p>
        ),
        notation: (
          <p>
            В качестве базовых наград Ambassador Case содержит <span style={{ color: 'white' }}>GAMED-поинты</span> и{' '}
            <span style={{ color: 'white' }}>неуникальные Telegram-подарки</span>. При получении уникальной награды бот
            отправит вам сообщение с номером транзакции, а амбассадор{' '}
            <span style={{ color: 'white' }}>сам свяжется с вами</span> и лично отправит подарок.
            <br />
            <br /> Обратите внимание: представители GAMED никогда не будут запрашивать ваши конфиденциальные данные!
          </p>
        ),
        content: {
          heading: 'Ambassador Case',
          description: 'Открывайте новый кейс и получайте памятные награды!',
        },
      },

      cargo: {
        heading: 'Груз прибыл!',
        description: (
          <span>
            <p style={{ margin: '0' }}>
              В GAMED новое обновление! Специально для <span style={{ color: 'white' }}>самых преданных фанатов </span>{' '}
              мы представляем долгожданный CARGO Case. Он содержит{' '}
              <span style={{ color: 'white' }}>увеличенное количество</span> GAMED-поинтов.
              <p>
                Больше нет необходимости открывать сотни стандартных кейсов - получите<span>всё и сразу</span> в одном
                наборе!{' '}
              </p>
            </p>
          </span>
        ),
        notation: (
          <p>
            Обратите внимание: для приобретения доступно<span style={{ color: 'white' }}> всего 100</span> CARGO-кейсов!{' '}
          </p>
        ),
        content: {
          heading: 'CARGO Case',
          description: 'Открывайте новый кейс и получайте памятные награды!',
        },
      },

      steamDeck: {
        heading: 'Steam On! Case в GAMED!',
        description: (
          <span>
            <p style={{ marginTop: '0px' }}>
              GAMED запускает уникальную акцию, в ходе которой у самых верных фанатов платформы есть шанс выиграть Steam
              Deck.
            </p>

            <p>Кейс доступен в течение короткого времени, а количество подарков строго ограничено!</p>
          </span>
        ),
        notation: (
          <span>
            <p>
              В качестве базовых наград Steam On! Case содержит <span style={{ color: 'white' }}>GAMED-поинты</span> и{' '}
              <span style={{ color: 'white' }}>уникальные Telegram-подарки</span>, а также{' '}
              <span style={{ color: 'white' }}>подписку GAMED Plus </span>на 1 год или 6 месяцев. При получении
              уникальной награды бот отправит вам сообщение с номером транзакции, а представитель GAMED{' '}
              <span style={{ color: 'white' }}>сам свяжется с вами</span>.
            </p>
            <p>
              {' '}
              Обратите внимание: представители GAMED <span style={{ color: 'white' }}>никогда</span> не будут
              запрашивать ваши конфиденциальные данные!
            </p>
          </span>
        ),
        content: {
          heading: 'Steam On! Case',
          description: 'Открывайте новый кейс и выиграйте игровую консоль!',
        },
      },
      playtest: {
        heading: 'Подключение Farcana в GAMED!',
        description: (
          <>
            <p style={{ margin: '0px' }}>
              Мы готовы к активному расширению и с гордостью представляем возможность подключения{' '}
              <span style={{ color: 'white' }}>Farcana</span>, бесплатной многопользовательской игры в
              научно-фантастическом сеттинге.
            </p>
            <p style={{ margin: '12px 0px' }}>
              Подключение Farcana уже доступно в <span style={{ color: 'white' }}>разделе "Платформы"</span>. Обратите
              внимание, что в ходе плейтеста вы можете принять участие в{' '}
              <span style={{ color: 'white' }}>ежедневном марафоне</span>, который доступен в секции "Задания".
            </p>
            <p style={{ margin: '0px' }}>
              Наконец, самый удачливый игрок, закрывший семидневный стрик, получит{' '}
              <span style={{ color: 'white' }}>лимитированную Playstation 5</span>, выполненную в стилистике PS 1!
            </p>
          </>
        ),

        notation: <></>,
      },
      cityholder: {
        heading: 'Награды от City Holder в GAMED!',
        notation: (handleClick: () => void) => (
          <span>
            <p>
              GAMED запускает коллаборацию с{' '}
              <span
                onClick={handleClick}
                style={{ color: '#4A6BFC' }}
              >
                City Holder
              </span>{' '}
              - первой в Telegram игрой в формате Build-to-Earn!
            </p>
            <p>
              Специально для новых пользователей мы разработали кейс, в котором помимо GAMED-поинтов можно получить
              <span style={{ color: 'white' }}> уникальные награды</span> для приложения City Holder, обеспечивающие
              повышенный доход и увеличивающие население.
            </p>
            <p>
              Внутриигровые предметы City Holder будут начисляться на аккаунт владельца{' '}
              <span style={{ color: 'white' }}>автоматически</span> после получения, а каждая награда от партнера может
              быть получена одним пользователем лишь <span style={{ color: 'white' }}>один раз</span>!
            </p>
          </span>
        ),
      },
      gigi: {
        heading: 'GIGI за часы, игры и ассеты!',
        notation: (
          <span>
            <p>
              В новом обновлении GAMED представляет{' '}
              <span style={{ color: 'white' }}>GIGI (Global Index of Gamer Impact)</span> - уникальный инструмент оценки
              игрового наследия геймеров.
            </p>
            <p>
              Раньше мы использовали GAMED-поинты для оценки <span style={{ color: 'white' }}>игровой активности</span>,
              однако со временем они "терялись" среди бонусов за выполнение заданий, открытие кейсов и приглашение
              друзей. Таким образом, игровой прогресс перестал играть{' '}
              <span style={{ color: 'white' }}>решающее значение</span> среди пользователей GAMED.
            </p>
            <p>
              GIGI позволяет нам вернуться к <span style={{ color: 'white' }}>первоначальной идее</span>. Очки этого
              индекса нельзя купить или получить за открытие лутбоксов, они начисляются исключительно за игровое
              наследие (игры, предметы, время) и служат превосходной{' '}
              <span style={{ color: 'white' }}>основой для формирования лидерборда</span>.
            </p>
            <p>
              В свою очередь, GAMED-поинты отнюдь не потеряют цену. Мы полностью готовы к тому, чтобы открыть
              возможность их <span style={{ color: 'white' }}>расходования</span>. Следите за следующими обновлениями!
            </p>
          </span>
        ),
      },
      ps5: {
        heading: 'PS 5 Limited Case в GAMED!',
        description: (
          <span>
            <p style={{ marginTop: '0px' }}>
              Мы продолжаем аттракцион невиданной щедрости и представляем новый кейс в GAMED, в котором у вас есть шанс
              выиграть консоль PlayStation 5 в уникальной ретро-стилистике PS1!
            </p>
          </span>
        ),
        notation: (
          <span>
            <p>
              В качестве базовых наград PS 5 Limited Case содержит <span style={{ color: 'white' }}>GAMED-токены</span>{' '}
              и <span style={{ color: 'white' }}>уникальные Telegram-подарки</span>, а также{' '}
              <span style={{ color: 'white' }}>подписку GAMED Plus</span> на 1 год или 6 месяцев. При получении
              уникальной награды бот отправит вам сообщение с номером транзакции, а представитель GAMED{' '}
              <span style={{ color: 'white' }}>сам свяжется с вами</span>.
            </p>
            <p>
              Обратите внимание: представители GAMED <span style={{ color: 'white' }}>никогда</span> не будут
              запрашивать ваши конфиденциальные данные!
            </p>
          </span>
        ),
        content: {
          heading: 'PS 5 Limited Case',
          description: 'Открывайте новый кейс и выиграйте игровую консоль!',
        },
      },
      telegramApps: {
        heading: 'Голосуй за GAMED!',
        description: (
          <>
            <p>
              GAMED участвует в голосовании в Telegram Apps Center, и сейчас нам особенно важна поддержка сообщества!
              Ваш голос — это вклад в развитие проекта и огромный буст для функциональности, контента и активности
              внутри приложения. Мы учитываем все предложения, идеи и просьбы, а это голосование как ничто поможет в
              реализации наших планов!
            </p>
            <p>Голосование займет всего пару секунд, но имеет огромное значение.</p>
            <p>
              В честь голосования мы также выпустили новый кейс — он уже доступен в приложении и содержит увеличенное
              количество GAMED-поинтов.
            </p>
          </>
        ),
      },
    },
    leaderboard: {
      header_tabs: {
        time: 'Часы',
        account_value: 'Ассеты',
        token_balance: 'Поинты',
      },
      total_value: 'Общая Стоимость Активов Геймеров',
      you: 'Ты',
      name: 'Имя',
      units: {
        hours: 'общее игровое время',
        assets: 'Оценка акк.',
        gamed: 'gamed',
        gigi: 'gigi',
      },
    },
    connection: {
      slide_1: {
        title: 'К сожалению, мы не можем.',
      },
      slide_2: {
        title: 'Но...',
      },
      slide_3: {
        title: 'Ты никогда не потеряешь опыт, который получил.',
      },
    },
    authPage: {
      data_using: {
        heading: 'Использование данных',
        parapraph:
          'Чтобы предоставить вам подробную и полезную игровую статистику, GAMED безопасно получает определенные публичные данные с вашего аккаунта Steam. ',
        what_we_collect: 'Вот что мы получаем и отображаем:',
        privacy_policy: {
          for_more_info: 'Для дополнительной информации рекомендуем ознакомиться с нашей',
          privacy_policy: 'политикой конфиденциальности',
          terms_of_service: 'условиями предоставления услуг.',
          and: 'и',
        },

        titles: {
          profile_information: 'Информация о профиле',
          game_library: 'Библиотека игр',
          playtime: 'Время в игре',
          inventory: 'Инвентарь',
          privacy_first: 'Конфиденциальность превыше всего',
        },

        descriptions: {
          profile_information:
            'Ваш никнейм, аватар и статус публичного профиля, чтобы персонализировать ваш опыт в GAMED.',
          game_library:
            'Список игр, которые вы приобрели, для точного отображения статистики и анализа вашей коллекции.',
          playtime: 'Часы, проведенные в каждой игре, чтобы показать ваши игровые привычки и выделить топовые проекты.',
          inventory:
            'Сведения о ваших внутриигровых предметах и их примерной рыночной стоимости, если они доступны публично.',
          privacy_first:
            'Мы получаем только публичные данные, которые вы сами сделали доступными через ваш профиль Steam. Мы не собираем и не храним вашу личную информацию, пароли или любые конфиденциальные данные.',
        },
      },
    },
    updatePage: {
      meet: 'ПРИВЕТСТВУЕМ',
      got_reward: 'Ваша награда зачислена на аккаунт',
      no_reward: 'Новой игровой активности не обнаружено. Играйте чаще, чтобы получить награду',
      account_age: 'Возраст аккаунта',
      games_owned: 'Игры в библиотеке',
      account_value: 'Стоимость аккаунта',
      items_owned: 'Предметов в инвентаре',
      total_playtime: 'игровое время',
      inventory_price: 'Стоимость инвентаря',

      total_value: 'Общая стоимость аккаунта',
      most_expensive: 'Самые дорогие предметы',
      new_most_expensive: 'Новые дорогие предметы',
      calculating: 'Идет расчет...',
    },

    topUpSteamPage: {
      heading: 'Пополнение Steam',
      step: 'Этап',
      firstStep: {
        chooseCountry: 'Выберите свой регион',
        steamLogin: 'Ваш логин Steam',
        amount: 'Сумма',
        willReceive: 'Получу, STEAM',
        minimalPaymentAmount: (min: number = 0.25, max: number = 200) =>
          `Мин. сумма пополнения: ${min} STEAM USD, \nМакс. сумма пополнения — ${max} STEAM USD`,
      },
      secondStep: {
        aboutToPay: 'Вы собираетесь оплатить',
        selectMethod: 'Выберите платежную систему',
      },

      countries: {
        ru: 'Россия',
        us: 'США',
        ir: 'Иран',
        ua: 'Украина',
        id: 'Индонезия',
        ae: 'ОАЭ',
        tr: 'Турция',
        fr: 'Франция',
        es: 'Испания',
        vn: 'Вьетнам',
        uz: 'Узбекистан',
        de: 'Германия',
        pl: 'Польша',
        kz: 'Казахстан',
        it: 'Италия',
      },
    },

    transactionStatus: {
      headings: {
        fetching: 'Проверка...',
        PAID: 'Операция прошла успешно',
        FAILED: 'Ошибка!',
        wentWrong: 'Упс! Что-то пошло не так',
        PENDING: 'Ожидание проверки...',
      },

      descriptions: {
        fetching: 'Ваш платеж обрабатывается. Не закрывайте это окно до завершения платежа!',
        PAID: 'Ожидайте, средства скоро будут зачислены на ваш аккаунт Steam',
        FAILED: 'Произошла ошибка при проведении транзакции! Попробуйте еще раз или обратитесь в поддержку',
        wentWrong: 'Пожалуйста, попробуйте провести транзакцию еще раз',
        PENDING:
          'Мы подготавливаем все необходимое для валидации платежа. Не закрывайте это окно до подтверждения платежа!',
      },
    },

    transactionHistory: {
      heading: 'История Транзакций',
      paymentsWrapper: {
        steamAccount: 'Steam-аккаунт',
        pending: 'В обработке',
        error: 'Отменена',
        successful: 'Успешно',
        status: 'Статус:',
        refunded: 'Возврат',
      },
    },

    dailyBonus: {
      day: 'день',
      keys: 'Ключи',
      key: 'Ключ',
      claimed: 'Получено',
      playStation: '6 месяцев GAMED Plus & шанс выиграть PS5',
      default: {
        dailyRewards: 'Ежедневные награды',
        nextUnlock: 'Следующая награда:',
        claim: 'Забрать!',
        heading: 'GAMED Ежедневный бонус',
        plusRewards: 'Награды',
        freeRewards: 'Стандартные',
        subHeading: 'Получай награды каждый день',
      },
      farcana: {
        hardwareHeading: 'PlayStation®5 Limited Edition',
        hardwareDescription: <span>Количество консолей ограничено!</span>,
        heading: 'Награды Farcana Playtest',
        subHeading: 'Получай эксклюзивные награды!',
        panelHeading: 'Награды Farcana Playtest',
      },
    },

    errors: {
      private: {
        title: 'Ваш аккаунт приватный',
        sub_title: 'Следуйте инструкциям, чтобы сделать профиль публичным',
        text_w_link: (
          <p>
            В меню Steam в верхнем левом углу экрана перейдите в раздел 'Настройки', затем выберите 'Настройки
            приватности'. <u>Все параметры</u> в этом разделе должны быть изменены на 'Открытый'
          </p>
        ),

        my_profile: 'Мой профиль',
        will_enalbe: 'Благодаря этому вся статистика будет доступна для GAMED!',
        private: 'СКРЫТЫЙ',
        public: 'ОТКРЫТЫЙ',
        manage_settings: 'Настроить профиль Steam',
        refresh: 'Обновить',
        settings: {
          inventory: 'Инвентарь',
          details: 'Основное',
          friends: 'Друзья',
          game: 'Инф. об играх',
        },
        list_title: 'Или сделай это вручную: ',
        list_item_1: `В своем профиле Steam нажми на ссылку «Редактировать профиль» под своим значком.`,
        list_item_2: `Перейди на вкладку «Настройки приватности».`,
        list_item_3: `Выбери нужный уровень приватности (все изменения сохраняются автоматически).`,
        btn_text: 'Попробовать снова',
      },

      smth_went_wrong: {
        title: 'Упс…',
        sub_title: 'Кажется, что-то пошло не так.',
        text: 'Не паникуйте! Просто расслабьтесь и попробуйте снова.',
        tip: (
          <p>
            Перейдите в <a href="https://t.me/gamedcommunitycis">новостной канал GAMED</a> для просмотра последних
            новостей или спросите пользователей в <a href="https://t.me/gamedchatcis">чате</a>.
          </p>
        ),
        btnText: 'Попробовать снова',
      },

      doubleConnection: {
        steam: {
          heading: 'Ошибка подключения',
          description: 'Этот аккаунт Steam уже привязан к другому Telegram-профилю.',
          twice: ' Вы не можете использовать его повторно.',
          connect_another: 'Подключить другой аккаунт',
          continue_withiout: 'Продолжить без Steam',
        },
        farcana: {
          heading: 'Ошибка подключения',
          description: 'Этот аккаунт Steam уже привязан к другому Telegram-профилю.',
          twice: ' Вы не можете использовать его повторно.',
          connect_another: 'Подключить другой аккаунт',
          continue_withiout: 'Продолжить без Steam',
        },
        egs: {
          heading: 'Ошибка подключения',
          description:
            'Эта учетная запись Epic Games уже привязана к другому профилю Telegram. Вы не можете использовать её дважды.',
          twice: ' Вы не можете использовать его повторно.',
          connect_another: 'Подключить другой аккаунт',
          continue_withiout: 'продолжить без Epic Games',
        },
      },
    },
    btnTexts: {
      continue: 'Продолжить',
      next: 'Далее',
      back: 'Назад',
      start: 'Начать',
      stop: 'Завершить',
      update: 'Обновить',
      share: 'Поделиться',
      share2: 'Поделиться',
      profile: 'Показать профиль',
      invite: 'Пригласить друзей',
      claim: 'Забрать',
      done: 'Готово',
      check: 'Проверить',
      time: 'Перейти в GAMED!',
      buyKeys: 'Купить Ключи',
      use: 'Использовать',
      buy: 'Купить',
      open: 'Открыть',
      openBox: 'Открыть',
      openNow: 'Открыть!',
      openGiftCase: 'Открыть кейс!',
      key: 'Ключ',
      claimKey: 'Получить',
      openCase: 'Открыть кейс!',
      openMore: 'Открыть ещё',
      close: 'Закрыть',
      pay: 'Оплатить',
      receive: 'Получить',
      completeTasks: 'К уникальным заданиям!',
      participate: 'Участвовать!',
      towardsVictories: 'К новым победам!',
      voteNow: 'Голосовать сейчас!',
      updateProgress: 'Обновить прогресс',
    },

    units: {
      dollar: '$',
      hours: 'Ч',
      days: 'Д',
      minutes: 'М',
      years: 'ЛЕТ',
      year: 'Год',
      months: 'Месяцев',
      gamed: 'GAMED',
      gigi: 'GIGI',
      value: 'Значение',
    },
  },
  news: {
    gigi: {
      preview: {
        title: 'GIGI Индекс',
        description: 'Новое обновление!',
      },
    },
    egs: 'Новая платформа в GAMED!',
    playstation: 'PS5 Case в',
  },
}
